import * as React from 'react';

export const BadgePreloader: React.SFC<{}> = () => {
    const styles = [
        'analyzer',
        'organizer',
        'catalyst',
        'pragmatist',
        'evaluator',
        'relator',
        'maverick',
        'strategist'
    ];

    const badges: string[] = [];
    styles.forEach(style => {
        badges.push(`/images/badges/${style} icon.svg`);
        badges.push(`/images/badges/${style} icon-white.svg`);
    });

    return (
        <div style={{ display: 'none' }} aria-hidden="true">
            {badges.map(src => (
                <img key={src} src={src} />
            ))}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/BadgePreloader.tsx